<div class="ocr-dialog">
  <h2 class="ocr-title">Añadir {{ pages }} páginas OCR</h2>

  <p class="ocr-line">Este paquete se cobrará como pago único.</p>
  <p class="ocr-price">{{ oneTimeCost | number : '1.2-2' }} €</p>
  <p class="ocr-note">Puedes volver a comprar más páginas cuando lo necesites.</p>

  <div class="ocr-actions">
    <button type="button" class="btn-cancel" (click)="close()">Cancelar</button>
    <button type="button" class="btn-ok" (click)="confirm()">Comprar páginas</button>
  </div>
</div>
